<div class="package-grid-container">
    <app-sales-package-grid-card *ngFor="let package of packages; trackBy: trackById" [package]="package" (packageSelected)="onPackageSelected($event)"></app-sales-package-grid-card>
</div>
